import { Dispatch, SetStateAction } from 'react';

import { Button } from '../../../styles/GlobalComponents';

import { P2 } from '../../../styles/FontStyles';
import { VirtualOfficePlan } from './VirtualOfficePlan';

interface VirtualOfficeSelectedPlanProps {
  setStep: Dispatch<SetStateAction<number>>;
  setSelected: Dispatch<SetStateAction<number>>;
  selected: any;
  buttonText: string;
}

export const VirtualOfficeSubscription = ({
  selected,
  setSelected,
  setStep,
  buttonText
}: VirtualOfficeSelectedPlanProps) => {
  return (
    <div>
      <VirtualOfficePlan selected={selected} setSelected={setSelected} />

      <P2 mb='40'>
        It is highly advised to select a multi-year access and{' '}
        <b>avoid the big risk</b> of losing the benefits in case you do not
        renew the Back-Office in time.
      </P2>

      <Button
        mb={40}
        onClick={() => {
          setStep(2);
          setSelected(selected);
        }}>
        {buttonText}
      </Button>
    </div>
  );
};
